export default {
  title: 'Two-factor account authentication',
  subtitle: 'Keep your account better protected!',
  requiredDescription:
    'The software will <b>require</b> <b>two-factor authentication (2FA)</b> for your account. To continue, please select one of the two authentication methods below:',
  viaGoogle: 'Authenticate via the <b>Google Authenticator</b> app',
  viaEmail: 'Authenticate via <b>Email</b>',
  googleAuthenticator: 'Google Authenticator',
  email: 'Email',
  recommended: '(Recommended)',
  followGoogle: 'Follow these steps to authenticate with <b>Google Authenticator</b>',
  followEmail: 'Follow these steps to authenticate with <b>Email</b>',
  step1: 'Step 1',
  step2: 'Step 2',
  step3: 'Step 3',
  step1Download: 'Download the <b>Google Authenticator</b> app from',
  appStore: 'App Store (iOS)',
  googlePlay: 'CH Play (Android)',
  or: 'or',
  step2Google: 'Open the app, tap “+” and select <b>Scan QR code</b> to generate an authentication code',
  step3Google: 'Enter the 6-digit authentication code in the app to complete',
  step1Email: '<b>Enter the email</b> you want to use for two-factor authentication and click <b>Send code</b>',
  step2Email: 'Enter the authentication code sent to your email to complete',
  codePlaceholder: 'Authentication code',
  authenticationCode: 'Authentication code',
  sendCode: 'Send code',
  resendCode: 'Resend code ({seconds}s)',
  buttons: {
    logout: 'Logout',
    continue: 'Continue',
    back: 'Back',
    close: 'Close',
    done: 'Done',
    cancel: 'Cancel',
  },
  validation: { email: 'Please enter the email', code: 'Please enter the code' },
  errors: {
    tooManyAttempts: 'Too many attempts. Try again in 30 minutes.',
    incorrectCode: 'Incorrect code',
  },
  successTitle: 'Two-factor authentication (2FA) enabled successfully',
  successViaGoogle: 'You have enabled two-factor authentication via the',
  successViaEmail: 'You have enabled two-factor authentication via',
  additionalMethod: 'You can set up an additional authentication method via',
  here: 'here',
  otp: {
    title: 'Enter OTP code',
    descGoogle: 'Enter the OTP from the',
    googleApp: 'Google Authenticator app',
    descEmail: 'Enter the OTP sent to email',
    verify: 'Authenticate',
    rememberDevice: 'Do not ask again on this device',
    authWithEmail: 'Authenticate with Email',
    authWithGoogle: 'Authenticate with Google Authenticator',
    backToLogin: 'Back to login',
  },
  enterPassword: {
    title: 'Enter password to proceed',
    description: 'Enter password to proceed',
    required: 'Please enter the password',
    incorrect: 'Incorrect password.',
  },
  info: {
    title: 'Two-factor authentication',
    methodsTab: 'Your authentication method',
    devicesTab: 'Signed-in devices',
    googleTitle: 'Authenticate via the Google Authenticator app',
    googleDescription:
      'Scan the QR code with the Google Authenticator app to link, then use the 6-digit code generated by the app to authenticate each time you log in.',
    emailTitle: 'Authenticate via Email',
    emailDescription:
      'The system will send a 6-digit code to the email you used to register for authentication. Use this code to authenticate each time you log in.',
    registeredEmail: 'Registered email:',
    deleteMethod: 'Delete authentication method',
    settings: 'Authentication settings',
    deleteEmail: 'Delete email',
    addEmail: 'Add email',
    devices: 'Devices',
    dateTime: 'Time',
    ip: 'IP',
  },
  authenticationVia: 'Authenticate via',
  twoFactor: 'two-factor authentication (2FA)',
  download: 'Download the',
  from: 'from the',
  openApp: 'Open the app, tap',
  select: 'and select',
  generateCode: 'to generate an authentication code',
  emailStep2: 'Enter the authentication code sent to your email to complete',
  emailPlaceholder: 'Email',
  confirm: {
    deleteDeviceTitle: 'Delete device',
    deleteDevice: 'Are you sure you want to delete the device <b>{device}</b>?',
    deleteMethodTitle: 'Delete authentication method',
    deleteMethod: 'Are you sure you want to delete the authentication method?',
    yes: 'Yes',
    no: 'No',
  },
};
